import NavbarSection from "@/components/LandingPage/Navbar/NavbarSection.vue";
import FooterSection from "@/components/LandingPage/Footer/FooterSection.vue";

const PRICING_PLANS = [
  {
    id: 1,
    name: "Free",
    tagline: "Get started with basic B-BBEE tracking",
    price: "R0",
    period: "/month",
    icon: "bi bi-lightning-charge",
    features: [
      "1 Organisation",
      "Basic dashboard",
      "Up to 3 team members",
      "Community support",
      "Basic reporting",
    ],
    button_text: "Get Started",
    button_link: "/login",
    highlighted: false,
  },
  {
    id: 2,
    name: "Silver",
    tagline: "For growing businesses with compliance needs",
    price: "R2000",
    period: "/month",
    icon: "bi bi-stars",
    features: [
      "1 Organisation",
      "Full dashboard access",
      "Up to 10 team members",
      "Email support",
      "Advanced reporting",
      "Document management",
      "Verification tracking",
    ],
    button_text: "Start Free Trial",
    button_link: "/login",
    highlighted: false,
  },
  {
    id: 3,
    name: "Gold",
    tagline: "Complete compliance solution for enterprises",
    price: "R3,500",
    period: "/month",
    icon: "bi bi-award",
    features: [
      "Up to 5 Organisations",
      "Full dashboard access",
      "Unlimited team members",
      "Priority support",
      "Custom reporting",
      "API access",
      "Dedicated account manager",
      "Audit & compliance logs",
    ],
    button_text: "Start Free Trial",
    button_link: "/login",
    highlighted: true,
  },
  {
    id: 4,
    name: "Diamond",
    tagline: "Enterprise-grade solution for consulting firms",
    price: "Custom",
    period: "",
    icon: "bi bi-gem",
    features: [
      "Unlimited Organisations",
      "Multi-client management",
      "White-label options",
      "24/7 dedicated support",
      "Custom integrations",
      "SLA guarantee",
      "On-premise deployment",
      "Custom training & onboarding",
    ],
    button_text: "Contact Sales",
    button_link: "/login",
    highlighted: false,
  },
];

export default {
  name: "pricing_component",
  components: {
    NavbarSection,
    FooterSection,
  },
  data() {
    return ({
      pricing_plans: PRICING_PLANS,
    });
  },

  methods: {
    navigateTo(link) {
      // Using Vue Router if available
      if (this.$router) {
        this.$router.push(link);
      } else {
        // Fallback to regular navigation
        window.location.href = escape(link);
      }
    }
  }
};